/*@flow*/

export default [
  'developments',
  'listings',
  'businesses',
  'streetscape_assets',
  'units',
  'streetscape_issues',
  'contacts',
  'events',
  'properties',
  'buildings',
];
